import React, { useState } from 'react';
import { MortgageInputForm } from './MortgageInputForm';
import { LenderOffers } from './LenderOffers';
export function RateAITab() {
  const [showOffers, setShowOffers] = useState(false);
  const [mortgageDetails, setMortgageDetails] = useState({
    amount: 500000,
    downPayment: 100000,
    amortization: 25,
    propertyType: 'Single Family',
    propertyUse: 'Primary Residence'
  });
  const handleGetRates = (formData: any) => {
    setMortgageDetails(formData);
    setShowOffers(true);
  };
  return <div className="bg-white rounded-lg shadow-sm p-6" data-id="element-524">
      <h2 className="text-2xl font-semibold text-neutral-900 mb-6" data-id="element-525">
        Rate AI - Mortgage Offers
      </h2>
      {/* Canadian Banks List */}
      <div className="mb-8" data-id="element-526">
        <h3 className="text-lg font-medium text-neutral-700 mb-3" data-id="element-527">
          Available Lenders
        </h3>
        <div className="flex flex-wrap gap-3" data-id="element-528">
          {['TD', 'CIBC', 'RBC', 'Scotiabank', 'BMO', 'National Bank', 'HSBC', 'Tangerine', 'Desjardins'].map(bank => <div key={bank} className="px-4 py-2 bg-white border border-neutral-200 rounded-md text-neutral-700 font-medium shadow-sm" data-id="element-529">
              {bank}
            </div>)}
        </div>
      </div>
      {/* Mortgage Input Form */}
      {!showOffers ? <MortgageInputForm onSubmit={handleGetRates} initialValues={mortgageDetails} data-id="element-530" /> : <div data-id="element-531">
          <div className="mb-6 p-4 bg-neutral-50 rounded-lg border border-neutral-200" data-id="element-532">
            <h3 className="text-lg font-medium text-neutral-700 mb-2" data-id="element-533">
              Mortgage Details
            </h3>
            <div className="grid grid-cols-2 md:grid-cols-3 gap-4" data-id="element-534">
              <div data-id="element-535">
                <p className="text-sm text-neutral-500" data-id="element-536">Mortgage Amount</p>
                <p className="font-medium" data-id="element-537">
                  ${mortgageDetails.amount.toLocaleString()}
                </p>
              </div>
              <div data-id="element-538">
                <p className="text-sm text-neutral-500" data-id="element-539">Down Payment</p>
                <p className="font-medium" data-id="element-540">
                  ${mortgageDetails.downPayment.toLocaleString()}
                </p>
              </div>
              <div data-id="element-541">
                <p className="text-sm text-neutral-500" data-id="element-542">Amortization</p>
                <p className="font-medium" data-id="element-543">
                  {mortgageDetails.amortization} years
                </p>
              </div>
              <div data-id="element-544">
                <p className="text-sm text-neutral-500" data-id="element-545">Property Type</p>
                <p className="font-medium" data-id="element-546">{mortgageDetails.propertyType}</p>
              </div>
              <div data-id="element-547">
                <p className="text-sm text-neutral-500" data-id="element-548">Property Use</p>
                <p className="font-medium" data-id="element-549">{mortgageDetails.propertyUse}</p>
              </div>
            </div>
            <button onClick={() => setShowOffers(false)} className="mt-4 px-4 py-2 text-primary-600 text-sm font-medium hover:bg-primary-50 rounded-md" data-id="element-550">
              Edit Details
            </button>
          </div>
          {/* Lender Offers */}
          <LenderOffers data-id="element-551" />
        </div>}
    </div>;
}